var _circle, _mask, _rect, _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgFax(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 48 48",
    fill: "none"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 24,
    r: 24,
    fill: "#E8F3FE"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "fax_svg__path-2-inside-1",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 14,
    y: 20,
    width: 20,
    height: 14,
    rx: 1
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 14,
    y: 20,
    width: 20,
    height: 14,
    rx: 1,
    stroke: "#3779CF",
    strokeWidth: 4,
    mask: "url(#fax_svg__path-2-inside-1)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 25h8M17 17h14M19 13h10",
    stroke: "#3779CF",
    strokeWidth: 2,
    strokeLinecap: "round"
  })));
}

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNDgiIGhlaWdodD0iNDgiIHZpZXdCb3g9IjAgMCA0OCA0OCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGNpcmNsZSBjeD0iMjQiIGN5PSIyNCIgcj0iMjQiIGZpbGw9IiNFOEYzRkUiLz4KPG1hc2sgaWQ9InBhdGgtMi1pbnNpZGUtMSIgZmlsbD0id2hpdGUiPgo8cmVjdCB4PSIxNCIgeT0iMjAiIHdpZHRoPSIyMCIgaGVpZ2h0PSIxNCIgcng9IjEiLz4KPC9tYXNrPgo8cmVjdCB4PSIxNCIgeT0iMjAiIHdpZHRoPSIyMCIgaGVpZ2h0PSIxNCIgcng9IjEiIHN0cm9rZT0iIzM3NzlDRiIgc3Ryb2tlLXdpZHRoPSI0IiBtYXNrPSJ1cmwoI3BhdGgtMi1pbnNpZGUtMSkiLz4KPHBhdGggZD0iTTIwIDI1SDI4IiBzdHJva2U9IiMzNzc5Q0YiIHN0cm9rZS13aWR0aD0iMiIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIi8+CjxwYXRoIGQ9Ik0xNyAxN0gzMSIgc3Ryb2tlPSIjMzc3OUNGIiBzdHJva2Utd2lkdGg9IjIiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIvPgo8cGF0aCBkPSJNMTkgMTNMMjkgMTMiIHN0cm9rZT0iIzM3NzlDRiIgc3Ryb2tlLXdpZHRoPSIyIiBzdHJva2UtbGluZWNhcD0icm91bmQiLz4KPC9zdmc+Cg==";
export { SvgFax as ReactComponent };